@if (areFaqsLoading) {
  <div sd-loader></div>
}
@if (faqsByCategory?.size > 0) {
  @if (jsonLdFaqs) {
    <span [wcCxJsonLd]="jsonLdFaqs"></span>
  }

  <sd-accordion-group [closeOthers]="false" [hideOthers]="false">
    @for (category of faqsByCategory | keyvalue; track category.key) {
      <sd-accordion
        [theme]="themesTextEnum.brand"
        [title]="category.key"
        [isNested]="true"
        (toggled)="onOpened($event, $index, category.key)"
      >
        @if (openedFaqs[$index]) {
          <wc-base-faq [faqEntries]="category.value" [addjsonLdFaqs]="false" />
        }
      </sd-accordion>
    }
  </sd-accordion-group>
}
